import React from 'react'; 
import Homepage from './Homepage'


function App() {
  return(
    <div> 
        <Homepage /> 
    </div>
  );
}
export default App;
